import { render, staticRenderFns } from "./mtCloseAccount.vue?vue&type=template&id=3132aace&"
import script from "./mtCloseAccount.vue?vue&type=script&lang=js&"
export * from "./mtCloseAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3132aace')) {
      api.createRecord('3132aace', component.options)
    } else {
      api.reload('3132aace', component.options)
    }
    module.hot.accept("./mtCloseAccount.vue?vue&type=template&id=3132aace&", function () {
      api.rerender('3132aace', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Clearing/mtCloseAccount.vue"
export default component.exports